// ----------------------------------------------------------------------------------------

// Reference variables

// ----------------------------------------------------------------------------------------

let savedCart;
let gwpSettings;
let giftFormInitialized = false;

let eligibleInCart = 0;


// ----------------------------------------------------------------------------------------

// Global Cart Change Listener Functionality

// ----------------------------------------------------------------------------------------

function handleCartChange(payload) {
    currentCartItems = payload
    if (savedCart && savedCart === payload) return;
    savedCart = payload || [];
    //updateCartGifts('drawer', payload)

}

// ----------------------------------------------------------------------------------------

// Specific event-based functionality

// ----------------------------------------------------------------------------------------

function updateCartGifts(changeType, payload) {
    let inCartItems = payload.items ? payload.items : payload;
    const giftSettings = gwpSettings ? gwpSettings : parseCodeGiftSettings();

    if (giftSettings) {
        if (!giftFormInitialized) {
            initGiftForm()
            giftFormInitialized = true;
        }
        const triggerItems = parseEligibleItems(giftSettings.trigger_item_type);
        const eligibleItemCount = parseItemTypeCount(inCartItems, triggerItems);
        const allottedGiftCount = Math.floor(eligibleItemCount / giftSettings.threshold);
        let giftCount = parseGiftCount(inCartItems);
        if (allottedGiftCount === giftCount) return;
        if (allottedGiftCount > giftCount) {
            enableGiftAddition(allottedGiftCount)
        } else if (allottedGiftCount < giftCount){
            parseExcessGifts(inCartItems, giftCount - allottedGiftCount)
        }
    } else {
        const eligbleProductId = sessionStorage.getItem('gift_session_item');
        if (!eligbleProductId) return;

        const eligibleIds = eligbleProductId.split(',').map(Number)

        // Check and handle gift removal
        const giftEligibleItems = inCartItems.filter(item => eligibleIds.includes(item.product_id) && (item.properties.is_gift || item.properties.is_gift !== 'true'))
        const giftItems = inCartItems.filter(item => item.properties.is_gift && item.properties.is_gift === 'true')

        const giftEligibleQuantity = giftEligibleItems.reduce((sum, item) => sum + item.quantity, 0);
        const giftsToRemove = giftItems.filter(item => item.properties._gift_quantity_threshold > giftEligibleQuantity)
        const giftsOverLimit = giftItems.filter(item => item.properties._gift_quantity_threshold <= giftEligibleQuantity && item.quantity > 1)

        if (giftsToRemove.length > 0 || giftsOverLimit.length > 0) {
            let updates = {};
            giftsToRemove.forEach(gift => {
                updates[gift.key] = 0
            })
            giftsOverLimit.forEach(gift => {
                updates[gift.key] = 1
            })


            handleGiftQtyUpdates(updates)
            return
        }

        // Check and handle gift addition
        const giftsToAdd = [];

        if (sessionStorage.getItem('gift-set')) {
            const matchingSet = giftSets.find(giftSet => giftSet.id === sessionStorage.getItem('gift-set'))
            if (!matchingSet) return;            
            matchingSet.gift_items.forEach(giftItem => {
                if (giftItem.variant_id) {
                    let inCart = giftItems.filter(gift => gift.id === giftItem.variant_id)
                    if (inCart.length === 0) {
                        let eligible = giftItem.threshold <= giftEligibleQuantity
                        if (eligible) {
                            giftsToAdd.push({
                                'id': giftItem.variant_id,
                                'quantity': 1, // Update later to item.per_add to support variable quantities
                                'properties': {
                                    'is_gift': "true",
                                    '_gift_session_id': sessionStorage.getItem('gift_session_id'),
                                    '_gift_quantity_threshold': giftItem.threshold
                                }
                            })
                        }
                    }
                }
            })
        }

        if (giftsToAdd.length > 0) {
            handleGiftAddition(giftsToAdd)
        }

        if (document.querySelector('[data-content="item-gift-display"]')) {
            updateGiftDisplayComponents()
        }

    }
}

async function handleGiftAddition(items) {
    const activeCart = document.querySelector('cart-drawer') || document.querySelector('cart-items');
    const sections = activeCart ? activeCart.getSectionsToRender().map((section) => section.id) : [];
    const sectionsUrl = window.location.pathname;

    const giftsDisplay = document.querySelector('.drawer-giftlist--items')
    const displayPlaceholder = generateGiftPlaceholder()
    if (giftsDisplay) {
        giftsDisplay.appendChild(displayPlaceholder)
    } else {
        const parent = document.querySelector('.drawer__cart-items-wrapper')
        const giftListWrapper = document.createElement('div')
        giftListWrapper.role = "row"
        giftListWrapper.id = "CartDrawer-Gifts"
        giftListWrapper.classList.add('cart-gift--list')
        giftListWrapper.innerHTML = `
            <div class="drawer-giftlist--wrapper">
                <h4 class="drawer-giftlist--title mt0 mb0">🎉 Included Free Gift${items.length > 1 ? "s" : ""} 🎉</h4>
                <div class="drawer-giftlist--items">
                    <div class="drawer-giftlist--item">
                        ${displayPlaceholder.innerHTML}
                    </div>
                    <div class="drawer-giftlist--item ${items.length > 1 ? "" : "hidden"}">
                        ${displayPlaceholder.innerHTML}
                    </div>
                </div>
            </div>
        `
        parent.appendChild(giftListWrapper)
    }

    const cartAddResponse = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        "method": "POST",
        "headers": {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
        },
        "body": JSON.stringify({ 
            'items': items,
            'sections': sections,
            'sections_url': sectionsUrl
        })
    })
    
    const sectionsData = await cartAddResponse.json();
    const parsedState = {
        sections: sectionsData.sections
    }

    if (document.querySelector('cart-drawer')) {
        document.querySelector('cart-drawer').renderContents(parsedState);
    }

}

async function handleGiftQtyUpdates(updates) {
    const activeCart = document.querySelector('cart-drawer') || document.querySelector('cart-items');
    const sections = activeCart ? activeCart.getSectionsToRender().map((section) => section.id) : [];
    const sectionsUrl = window.location.pathname;

    const qtyUpdatesResponse = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
        "method": "POST",
        "headers": {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
        },
        "body": JSON.stringify({ 
            'updates': updates,
            'sections': sections,
            'sections_url': sectionsUrl
        })
    })
    
    const sectionsData = await qtyUpdatesResponse.json();

    const parsedState = {
        sections: sectionsData.sections
    };

    if (document.querySelector('cart-drawer')) {
        document.querySelector('cart-drawer').renderContents(parsedState);
    }

    crossCheckCartPrices(sessionStorage.getItem('discount-code', sessionDiscount))
}

function updateGiftDisplayComponents() {
    const displayComponents = document.querySelectorAll('[data-content="item-gift-display"]')
    if (displayComponents.length === 0) return;
    let maxThreshold = 0;
    displayComponents.forEach(component => {
        const parent = component.closest('form')
        const quantity = parseInt(parent.querySelector('input[name="quantity"]').value) || 1
        const displayIndex = eligibleInCart + quantity;
        const componentItems = component.querySelectorAll('[data-gift-threshold]')
        const eligibleItems = Array.from(componentItems).filter(item => parseInt(item.getAttribute('data-gift-threshold')) <= displayIndex)
        componentItems.forEach(item => {
            const index = parseInt(item.getAttribute('data-gift-threshold'))
            if (index > maxThreshold && displayIndex >= index) {
                maxThreshold = index
            }
            item.classList.toggle('gift--active', displayIndex >= index)
            item.classList.toggle('gift--inactive', index > displayIndex)
        })
        component.querySelector('[data-content="gift-count"]').textContent = eligibleItems.length
    })
}

function enableGiftAddition(giftIndex) {
    toggleGiftModal(true)
    document.getElementById('gift-selection-form').setAttribute('data-gift-index', giftIndex)
}

function parseExcessGifts(items, removeCount) {
    const giftItems = items.filter(item => item.properties.is_gift === 'true');
    const sortedGifts = giftItems.sort((a, b) => {
        const indexA = parseInt(a.properties.gift_selection_index, 10);
        const indexB = parseInt(b.properties.gift_selection_index, 10);
        return indexB - indexA;
    })
    let updates = {}
    for (let i = 0; i < removeCount; i++) {
        if (!sortedGifts[i]) break;
        updates[sortedGifts[i].key] = 0;
    }
    
    handleGiftQtyUpdates(updates)
}

function initBasicGiftEligibility() {
    const giftData = giftSets.find(set => set.id === sessionStorage.getItem('gift-set'))
    if (!giftData) return;
    
    giftData.trigger_items.forEach(item => {
        insertGiftPreview(giftData, item)
    })
}

function insertGiftPreview(giftData, item) {
    const addWrapper = document.querySelector(`[data-add-pid="${item}"]`)
    if (!addWrapper) return;
    const form = addWrapper.closest('form')
    const previewContent = generateGiftPreview(giftData, form);
    addWrapper.parentNode.insertBefore(previewContent, addWrapper)

    const refillGroup = form.querySelector('.refill-option--group')
    if (refillGroup) {
        refillGroup.classList.add('hidden')
    }

    form.querySelector('input[name="quantity"]').addEventListener('change', () => {
        updateGiftDisplayComponents()
    })
}

function generateGiftPlaceholder() {
    const displayPlaceholder = document.createElement('div')
    displayPlaceholder.classList.add('drawer-giftlist--item')
    displayPlaceholder.innerHTML = `
        <div class="drawer-gift--image image-shimmer--placeholder">
        </div>
                            
        <div class="drawer-gift--content">
            <div class="title-shimmer--placeholder"></div>
            <div class="pill-shimmer--placeholder"></div>
        </div>
    `
    return displayPlaceholder
}

function generateGiftTile(item, eligibleIndex) {
    const content = {
        'title': item.item_title || 'Mystery Gift',
        'image': item.image_url || 'https://cdn.shopify.com/s/files/1/1009/8326/files/free-mystery-gift-when-you-spend-20-561086-removebg-preview_1.png?v=1709185480',
        'threshold': item.threshold,
        'status': item.threshold > eligibleIndex ? 'gift--inactive' : 'gift--active'
    }
    const mysteryContent = {
        'title': 'Mystery Gift',
        'image': 'https://cdn.shopify.com/s/files/1/1009/8326/files/free-mystery-gift-when-you-spend-20-561086-removebg-preview_1.png?v=1709185480',
    }
    const htmlData = `
        <div class="pdp-gift--item ${content.status}" data-gift-threshold="${content.threshold}">
            <div class="active-gift--content">
                <div class="pdp-gift--display">
                    <img class="gift-item--image" src="${content.image}" alt="Free ${content.title} when you order ${content.threshold} or more items!">
                </div>
                <div class="pdp-gift--title">
                    ${content.title}                       
                </div>
            </div>
            <div class="inactive-gift--content">
                <div class="pdp-gift--display">
                    <img class="gift-item--image" src="${item.mystery ? mysteryContent.image : content.image }" alt="Free ${item.mystery ? mysteryContent.title : content.title } when you order ${content.threshold} or more items!">
                </div>
                <div class="pdp-gift--title">
                    ${item.mystery ? mysteryContent.title : content.title }
                </div>
            </div>
            <div class="gift-threshold--pill">
                Buy ${content.threshold}!
            </div>
        </div>
    `
    return htmlData
}

function generateGiftPreview(giftData, form) {
    const giftDisplay = document.createElement('div')
    const quantity = parseInt(form.querySelector('input[name="quantity"]').value) || 1
    giftDisplay.classList.add('pdp-gift--wrapper')
    const displayEligibility = eligibleInCart > 0 ? eligibleInCart + quantity : quantity
    let earnedCount = giftData.gift_items.filter(item => item.threshold <= displayEligibility).length
    let itemContent = '';
    giftData.gift_items.forEach(item => {
        itemContent += generateGiftTile(item, displayEligibility)
    })
    giftDisplay.innerHTML = `
        <div class="pdp-gift--flex" data-content="item-gift-display">
            <div class="pdp-summary--wrapper">
                <div class="pdp-gift--item">
                    <div class="pdp-gift--label">
                        <div class="offer-benefit--text">
                            ${giftData.display_label || 'Order Now to Claim FREE Gifts' }
                        </div>
                        <div class="pdp-gift--summary" data-content="gift-status">
                            <span data-content="gift-count">${earnedCount}</span>/${giftData.gift_items.length} Unlocked
                        </div>
                    </div>
                </div>
            </div>

            ${itemContent}
                        
        </div>
    `
    return giftDisplay
}

document.addEventListener('gift:eligible', initBasicGiftEligibility)

// ----------------------------------------------------------------------------------------

// Helper functions

// ----------------------------------------------------------------------------------------

function parseEligibleItems(itemType) {
    let ids = collectionGroups.find(group => group.name === itemType).ids;
    return ids.map(Number)
}

function parseCodeGiftSettings() {
    if (discountDetails.gwp_eligible) {
        let settings = {
            "trigger_item_type": discountDetails.gwp_type || null,
            "application_type": discountDetails.gwp_application || null,
            'threshold': discountDetails.gwp_threshold || null,
        }
        gwpSettings = settings;
        return settings
    }
    return
}

function parseItemTypeCount(items, eligibleIds) {
    return items
        .filter(item => eligibleIds.includes(item.product_id) && !item.properties['is_gift'])
        .reduce((acc, item) => acc + item.quantity, 0);
}

function parseGiftCount(items) {
    return items
        .filter(item => item.properties['is_gift'] === 'true')
        .reduce((acc, item) => acc + item.quantity, 0);
}

function toggleGiftModal(visible = false) {
    const target = document.querySelector('[data-content="modal"][data-modal-id="gift-selection"]')
    if (visible) {
        document.querySelector('cart-drawer').close();
        target.classList.add('transition')
        setTimeout(() => {
            target.classList.add('visible')
        }, 10)
        return
    }
    const form = document.getElementById('gift-selection-form')
    const button = form.querySelector('[type="submit"]')
    form.reset()
    button.disabled = true
    button.textContent = 'Confirm Selection'
    target.classList.remove('visible')
    setTimeout(() => {
        target.classList.remove('transition')
    }, 160)
}

function initGiftForm() {
    const form = document.getElementById('gift-selection-form');
    if (!form) return;
    form.addEventListener('submit', (event) => {
        event.preventDefault();
        giftFormSubmit(event);
    })
    form.querySelectorAll('input[type="radio"]').forEach(input => {
        input.addEventListener('change', (event) => {
            giftSelectionChange(event);
        })
    })
}

async function giftFormSubmit(event) {
    const activeCartObject = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    const sections = activeCartObject ? activeCartObject.getSectionsToRender().map((section) => section.id) : [];
    const sectionsUrl = window.location.pathname;

    const selected = event.target.querySelector('input[type="radio"]:checked');
    const button = event.target.querySelector('input[type="submit"]');
    button.textContent = 'Adding...'
    button.disabled = true

    const data = [{
        "id": selected.value,
        "quantity": 1,
        "properties": {
            "is_gift": "true",
            "gift_selection_index": event.target.getAttribute('data-gift-index'),
            "_item_uts": Date.now()
        }
    }]

    const body = {
        'items': data,
        "sections": sections,
        "sections_url": sectionsUrl
    }

    await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        "method": "POST",
        "headers": {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
        },
        "body": JSON.stringify(body)
    })
    .then(response => response.json())
    .then(response => {
        activeCartObject.renderContents(response)
        toggleGiftModal(false)
    })
    .catch((error) => {
        console.error('Error:', error);
    });
}

function giftSelectionChange(event) {
    const form = event.target.closest('form');
    const ready = form.querySelector('input[type="radio"]:checked') ? true : false;
    form.querySelector('input[type="submit"]').disabled = !ready;
}

// function getNewestGift(items) {
//     return items.reduce((highest, item) => {
//         const itemValue = parseFloat(item.properties?.gift_selection_index) || 0;
//         const highestValue = parseFloat(highest.properties?.gift_selection_index) || 0;
    
//         return itemValue > highestValue ? item : highest;
//     }, null);
// }